import { Link } from "react-router-dom";
import { Page } from "@/components/layout/Layout";
import { Button } from "@/components/ui/button";
import SEO from "@/components/common/SEO";

export default function NotFound() {
  return (
    <Page className="max-w-xl text-center py-20">
      <SEO title="404 - Sayfa Bulunamadı" description="Aradığınız sayfa bulunamadı." noIndex />
      <p className="eyebrow text-[#0071e3]">404 HATASI</p>
      <h1 className="mt-3 font-display text-4xl sm:text-5xl font-semibold tracking-tight text-zinc-900">
        Sayfa Bulunamadı
      </h1>
      <p className="mt-4 text-base text-zinc-500 leading-relaxed">
        Aradığınız sayfa silinmiş, taşınmış veya geçici olarak yayından kaldırılmış olabilir.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Button asChild size="lg" className="bg-[#0071e3] hover:bg-[#0077ed] text-white">
          <Link to="/">Ana Sayfaya Dön</Link>
        </Button>
        <Button asChild size="lg" variant="outline" className="border-black/[0.08] bg-black/[0.04] hover:bg-black/[0.08]">
          <Link to="/ilanlar">İlanlara Göz At</Link>
        </Button>
      </div>
    </Page>
  );
}
